
const Chicago = [
  {
    title: 'TO UIUC (2/28)',
    body: [
      {
        title: 'PICKUP',
        body: [
          {
            title: 'Northwestern - 12PM',
            body: 'Weinberg College of Arts and Science, 1918 Sheridan Rd, Evanston, IL',
          },
          {
            title: 'UIC - 1PM',
            body: 'Richard J. Daley Library, 801 South Morgan Street, Chicago, IL',
          },
          {
            title: 'DePaul - 1:30PM',
            body: 'CDM Center, 243 S Wabash Ave, Chicago, IL',
          },
          {
            title: 'Union Station - 2PM',
            body: '499 W Jackson Blvd, Chicago, IL',
          },
        ],
      },
      {
        title: 'ARRIVAL',
        body: [
          {
            title: 'UIUC - 4:30PM',
            body: 'Thomas M. Siebel Center for Computer Science, 201 N. Goodwin Ave, Urbana, IL',
          },
        ],
      },
    ],
  },
  {
    title: 'FROM UIUC (3/1)',
    body: [
      {
        title: 'PICKUP',
        body: [
          {
            title: 'UIUC - 4:30PM',
            body: 'Thomas M. Siebel Center for Computer Science, 201 N. Goodwin Ave, Urbana, IL',
          },
        ],
      },
      {
        title: 'ARRIVAL',
        body: [
          {
            title: 'Union Station - 7PM',
            body: '499 W Jackson Blvd, Chicago, IL',
          },
          {
            title: 'DePaul - 7:30PM',
            body: 'CDM Center, 243 S Wabash Ave, Chicago, IL',
          },
          {
            title: 'UIC - 8PM',
            body: 'Richard J. Daley Library, 801 South Morgan Street, Chicago, IL',
          },
          {
            title: 'Northwestern - 9PM',
            body: 'Weinberg College of Arts and Science, 1918 Sheridan Rd, Evanston, IL',
          },
        ],
      },
      {
        title: 'DISCLAIMER',
        body: [
          {
            title: 'All times are estimated.',
            body: 'Times could be subject to change.',
          },
        ],
      },
    ],
  },
];

const Indiana = [
  {
    title: 'TO UIUC (2/28)',
    body: [
      {
        title: 'PICKUP',
        body: [
          {
            title: 'IUPUI - 1PM EST',
            body: 'Computer and Information Science Department, 732 W Michigan St, Indianapolis, IN',
          },
          {
            title: 'Purdue - 3PM EST',
            body: 'Richard and Patricia Lawson Computer Science Building, 305 N University St, West Lafayette, IN',
          },
        ],
      },
      {
        title: 'ARRIVAL',
        body: [
          {
            title: 'UIUC - 3:30PM CST',
            body: 'Thomas M. Siebel Center for Computer Science, 201 N Goodwin Ave, Urbana, IL',
          },
        ],
      },
    ],
  },
  {
    title: 'FROM UIUC (3/1)',
    body: [
      {
        title: 'PICKUP',
        body: [
          {
            title: 'UIUC - 4:30PM CST',
            body: 'Thomas M. Siebel Center for Computer Science, 201 N Goodwin Ave, Urbana, IL',
          },
        ],
      },
      {
        title: 'ARRIVAL',
        body: [
          {
            title: 'Purdue - 7PM EST',
            body: 'Richard and Patricia Lawson Computer Science Building, 305 N University St, West Lafayette, IN',
          },
          {
            title: 'IUPUI - 9PM EST',
            body: 'Computer and Information Science Department, 732 W Michigan St, Indianapolis, IN',
          },
        ],
      },
      {
        title: 'DISCLAIMER',
        body: [
          {
            title: 'All times are estimated.',
            body: 'Times could be subject to change.',
          },
        ],
      },
    ],
  },
];

const Locations = [Chicago, Indiana];
export default Locations;
